export default __webpack_public_path__ + "77c0522f6e4a0f6e06a0c0da4f1ee43f.svg";